import { makeTypes, asyncMac, mac, createReducer, reduceReducers } from 'ducks-maker'
import { createFetch, editFetch, addFetch, selectHOR, removeErrorHOR } from './hors.js'
import { leer, modificar, crear } from '../services/api'

const t = makeTypes('colores')
const FETCH = t('fetch').async()
const EDIT = t('edit').async()
const SELECT = t('select').single()
const ADD = t('add').async()
const REMOVEERROR = t('removeError').single()

const fetchActions = asyncMac(FETCH)
const editActions = asyncMac(EDIT)
const addActions = asyncMac(ADD)
export const removeError = mac(REMOVEERROR)
export const selectColor = mac(SELECT,'payload')

const initialState = {
    data: [],
    fetched: false,
    fetching: false,
}

const fetchReducer = createReducer(initialState, createFetch( FETCH ))
const editReducer = createReducer(initialState, editFetch( EDIT ))
const addReducer = createReducer(initialState, addFetch( ADD ))
const removeErrorReducer= createReducer(initialState, removeErrorHOR({ REMOVEERROR }))
const selectReducer= createReducer(initialState, selectHOR({ SELECT }))


export default reduceReducers(fetchReducer, selectReducer, editReducer, addReducer, removeErrorReducer)

export const fetchColores = () => async (dispatch, getState) => {
    dispatch(fetchActions.start())
    try {
        const data = await leer('/color')
        dispatch(fetchActions.success(data))
    } catch (error) {
        dispatch(fetchActions.error(error))
    }
}

export const editarColores = (id, values) => async (dispatch, getState) => {
    dispatch(editActions.start())
    try {
        const data = await modificar('/color', id, values)
        dispatch(editActions.success(data))
    } catch (error) {
        dispatch(editActions.error(error))
    }
}

export const agregarColor = (values) => async (dispatch, getState) => {
    dispatch(addActions.start())
    try {
        const data = await crear('/color', values)
        dispatch(addActions.success(data))
    } catch (error) {
        dispatch(addActions.error(error))
    }
}
